<form [formGroup]="metricsForm">
  <div class="space-between-horizontal flex-wrap gap-x-[1rem] gap-y-[0.4rem] input-height-2">
    <app-input  data-qa="fs-fund-metrics-total-commitment"
                formControlName="totalCommitment"
                [title]="'Total commitment'"
                [thousandSeparator]="','"
                [separator]="'separator.0'"
                [additionalClass]="isModelBlocked ? 'disabled' : ''"
                (inputChange)="calculateMetrics($event, metrics.name.totalCommitment)"
                (blurEmitter)="emitSaveInputs()">
    </app-input>
    <app-input  data-qa="fs-fund-metrics-proceeds"
                formControlName="proceeds"
                [title]="'Proceeds/(Distribution)'"
                [additionalClass]="'disabled'"
                [thousandSeparator]="','"
                [separator]="'separator.0'">
    </app-input>
    <app-input  data-qa="fs-fund-metrics-expected-expenses"
                formControlName="expectedExpenses"
                [title]="'Expected expenses'"
                [thousandSeparator]="','"
                [separator]="'separator.0'"
                [additionalClass]="isModelBlocked ? 'disabled' : ''"
                (inputChange)="calculateMetrics($event, metrics.name.expectedExpenses)"
                (blurEmitter)="emitSaveInputs()">
    </app-input>
    <app-input  data-qa="fs-fund-metrics-expected-expenses-pcnt"
                formControlName="expectedExpensesPcnt"
                [suffix]="'%'"
                [separator]="'separator.2'"
                [title]="'Expected expenses, %'"
                [additionalClass]="isModelBlocked ? 'disabled' : ''"
                (inputChange)="calculateMetrics($event, metrics.name.expectedExpensesPcnt)"
                (blurEmitter)="emitSaveInputs()">
    </app-input>
    <app-input  data-qa="fs-fund-metrics-investment"
                formControlName="investment"
                [title]="'Investment'"
                [additionalClass]="'disabled'"
                [thousandSeparator]="','"
                [separator]="'separator.0'">
    </app-input>
    <app-input  data-qa="fs-fund-metrics-net-gain"
                formControlName="gain"
                [title]="'Net gain/(loss)'"
                [additionalClass]="'disabled'"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
                [separator]="'separator.0'">
    </app-input>
    <app-input  data-qa="fs-fund-metrics-unallocated-commitment"
                formControlName="unAllocatedCommitment"
                [title]="'Unallocated commitment/(Over the fund size)'"
                [additionalClass]="'disabled'"
                [thousandSeparator]="','"
                [allowNegativeNumbers]="true"
                [separator]="'separator.0'">
    </app-input>
    <app-input  data-qa="fs-fund-metrics-tvpi"
                formControlName="tvpi"
                [title]="'TVPI'"
                [additionalClass]="'disabled'"
                [prefix]="'x'"
                [separator]="'separator.2'">
    </app-input>
  </div>
</form>
